import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'react-dropdown/style.css';
import { getDayOfWeek } from '../utils/dates';
import { getDurationUnits } from '../utils/durationUnits'


export default class SpecialDealCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
          modalDetails: false,
        };
    
        this.toggle = this.toggle.bind(this);
    }
    
    toggle(property) {
        let newState = {};
        newState[property] = !this.state[property];
        this.setState(newState);
    }


    render() {
        let deal = this.props.deal;
        let isLoading = this.props.isLoading;
        const {handleDealDetail} = this.props;
           
        return (
                         
                <div className="package mt-3 bg-white">
                    <div className="row">
                        <div className="col-lg-7 col-md-12 col-sm-6">
                            <h5 className="mb-1">
                                <strong><a style={{cursor: "pointer"}} onClick={() => handleDealDetail()}>{deal.name}</a></strong>
                            </h5>
                            { deal.name !== deal.description &&
                                <p className="m-0 text-muted">{deal.description} </p>
                            }

                            <small>
                                { deal.daysOfWeekAvailable.length === 7 &&
                                    <em className="text-muted">Valid all days of the week</em>
                                }
                                { deal.daysOfWeekAvailable.length === 2 &&
                                    <em className="text-muted">Valid on {`${getDayOfWeek(deal.daysOfWeekAvailable[1])}`} and {`${getDayOfWeek(deal.daysOfWeekAvailable[0])}`}</em>
                                }
                                { deal.daysOfWeekAvailable.length < 7 && deal.daysOfWeekAvailable.length > 2 &&
                                    <em className="text-muted">Valid on {`${getDayOfWeek(deal.daysOfWeekAvailable[0])}`} to {`${getDayOfWeek(deal.daysOfWeekAvailable[deal.daysOfWeekAvailable.length-1]  )}`}</em>
                                }
                            </small>
                        </div>
                        <div className="col-lg-5 col-md-12 col-sm-6 text-sm-right text-md-left text-lg-right">
                            <a className="btn btn-outline-success" onClick={() => handleDealDetail()}>Buy €{deal.pricing.grossAmount.toFixed(2)}</a>
                            <div className="text-muted m-t-10">
                                <p className="pt-2 mb-1">
                                    <i className="fa fa-clock-o"></i>
                                    &nbsp;
                                    {deal.pricing.duration} {`${getDurationUnits(deal.pricing.durationUnits)}`}
                                    {deal.pricing.duration > 1 &&
                                        's'
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            
        );
    }
}

SpecialDealCard.propTypes = {
    deal: PropTypes.object,
    isLoading:PropTypes.bool,
    handleDealDetail:PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/SpecialDealCard.jsx